import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  title: () => i18n.t(i18nKeys.excitement__get_started__title),
  titleDefault: () => i18n.t(i18nKeys.excitement__get_started__title_default),
  titleSubmarket: () =>
    i18n.t(i18nKeys.excitement__get_started__title_submarket),
  titleSecondary: () =>
    i18n.t(i18nKeys.excitement__get_started__title__secondary),
  promotionsTitle: () =>
    i18n.t(i18nKeys.excitement__get_started__promotions__title),
  legalDisclaimer: () =>
    i18n.t(i18nKeys.excitement__get_started__legal__disclaimer),
  primaryAction: () => i18n.t(i18nKeys.excitement__get_started__primary_action),
  defaultCardTitle: () =>
    i18n.t(i18nKeys.excitement__get_started__default_title),
  defaultCardContent: () =>
    i18n.t(i18nKeys.excitement__get_started__default_content),
  defaultSecondaryCardTitle: () =>
    i18n.t(i18nKeys.excitement__get_started__default_secondary_title),
  defaultSecondaryCardContent: () =>
    i18n.t(i18nKeys.excitement__get_started__default_secondary_content),
  promoCardPeakPayTitle: () =>
    i18n.t(i18nKeys.excitement__promotional_card__peak_pay__title),
  promoCardPeakPayContent: ({
    monetaryDisplayString,
    startDate,
    endDate,
  }: {
    monetaryDisplayString: string
    startDate: string
    endDate: string
  }) =>
    i18n.t(i18nKeys.excitement__promotional_card__peak_pay__content, {
      monetaryDisplayString,
      startDate,
      endDate,
    }),
  promoCardHourlyPayTitle: () =>
    i18n.t(i18nKeys.excitement__promotional_card__hourly_pay__title),
  promoCardHourlyPayContent: ({
    monetaryDisplayString,
  }: {
    monetaryDisplayString: string
  }) =>
    i18n.t(i18nKeys.excitement__promotional_card__hourly_pay__content, {
      monetaryDisplayString,
    }),
  promoCardHourlyPayContentSubmarket: ({
    submarketName,
    monetaryDisplayString,
  }: {
    submarketName: string
    monetaryDisplayString: string
  }) =>
    i18n.t(
      i18nKeys.excitement__promotional_card__hourly_pay__content_submarket,
      {
        submarketName,
        monetaryDisplayString,
      }
    ),
  promoCardTransportationTitle: () =>
    i18n.t(i18nKeys.excitement__promotional_card__transportation__title),
  promoCardTransportationContent: () =>
    i18n.t(i18nKeys.excitement__promotional_card__transportation__content),
  promoCardDefaultTitle: () =>
    i18n.t(i18nKeys.excitement__promotional_card__default__title),
  promoCardDefaultContent: () =>
    i18n.t(i18nKeys.excitement__promotional_card__default__content),
  promoCardDefaultTitleAlt: () =>
    i18n.t(i18nKeys.excitement__promotional_card__default__title__alt),
  promoCardDefaultContentAlt: () =>
    i18n.t(i18nKeys.excitement__promotional_card__default__content__alt),
}
